export const formatTimestamp = (timestamp) => {
  // Assume timestamp is UTC and convert to local timezone
  const date = new Date(timestamp.includes('Z') ? timestamp : timestamp + 'Z');
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const messageDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  if (messageDate.getTime() === today.getTime()) {
    // Today - show time
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  } else if (messageDate.getTime() === yesterday.getTime()) {
    // Yesterday
    return 'Yesterday';
  } else {
    // Older - show date in day-first format
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  }
};

// TODO: clear chat list history in session if it exists!

export const regulatory_options = {
  Search: [
    'for compliance requirements on...',
    'NHS regulations on...',
    'standards for hospital estates on...',
    'policy guidance on...'
  ],
  Summarise: [
    'the following document...',
    'key compliance requirements around...',
    'the HTM regulations surrounding...',
    'key takeaways from this report...'
  ],
  Write: ['an email for...', 'a compliance report on...', 'an SOP for...', 'a briefing note relating to...'],
  Verify: [
    'if this paragraphs meets HTM guidelines...',
    'missing requirements in this report...',
    'regulatory risks in this document...',
    'grammar and spelling in this document...'
  ]
};
